import { useEffect } from 'react'
import { useRouter } from 'next/router'
import Error from 'src/components/Error'

const Error404Page= () => {
  const router = useRouter()

  useEffect(() => {
    if (router.asPath.includes('/noleggio-a-lungo-termine/')) {
      router.replace('/noleggio-a-lungo-termine')
    } else {
      router.replace('/')
    }
  }, [router.asPath])

  return <Error statusCode={404} />
}

export default Error404Page
